(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ebike-site-intake-preview"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
  var openButton = event.target.closest('[data-modal-open]');
  if (!openButton) return;
  var modal = document.getElementById(openButton.getAttribute('data-modal-open'));
  if (!modal || !modal.matches('#makeOfferModal, #reserveModal')) return;
  var dialog = modal.querySelector('.ebike-offer-modal__dialog, .ebike-reserve-modal__dialog');
  var wrap = modal.querySelector('.ebike-site-intake-wrap');
  modal.querySelector('[data-precheck]').hidden = false;
  wrap.hidden = true;
  wrap.querySelector('form').reset();
  wrap.querySelector('input[name="buyerMobile"]').setCustomValidity('');
  wrap.querySelector('form').hidden = false;
  var offerInput = wrap.querySelector('input[name="offerAmount"]');
  if (offerInput) offerInput.setCustomValidity('');
  var offerError = wrap.querySelector('[data-offer-error]');
  if (offerError) offerError.hidden = true;
  wrap.querySelector('button[type="submit"]').disabled = false;
  wrap.querySelector('[data-intake-preview-status]').hidden = true;
  if (dialog) dialog.scrollTop = 0;
}, true);
document.addEventListener('click', function (event) {
  var back = event.target.closest('[data-intake-back]');
  if (!back) return;
  var modal = back.closest('#makeOfferModal, #reserveModal');
  if (!modal) return;
  event.preventDefault();
  modal.querySelector('.ebike-site-intake-wrap').hidden = true;
  modal.querySelector('[data-precheck]').hidden = false;
  var dialog = modal.querySelector('.ebike-offer-modal__dialog, .ebike-reserve-modal__dialog');
  if (dialog) dialog.scrollTop = 0;
});
document.addEventListener('input', function (event) {
  if (!event.target.matches('.ebike-site-intake input[name="offerAmount"]')) return;
  event.target.setCustomValidity('');
  var offerError = event.target.closest('form').querySelector('[data-offer-error]');
  if (offerError) offerError.hidden = true;
});
function ebikeRejectLowOffer(offerInput) {
  var form = offerInput.closest('form');
  var askingPricePence = Number(form.dataset.askingPricePence);
  var minimumPence = Math.floor((askingPricePence * 70 + 99) / 100);
  var offerPence = Math.round(Number(offerInput.value) * 100);
  if (offerInput.value && Number.isSafeInteger(askingPricePence) && askingPricePence > 0 && offerPence < minimumPence) {
    offerInput.value = '';
    var offerError = form.querySelector('[data-offer-error]');
    if (offerError) offerError.hidden = false;
    return true;
  }
  return false;
}
document.addEventListener('change', function (event) {
  if (!event.target.matches('.ebike-site-intake input[name="offerAmount"]')) return;
  ebikeRejectLowOffer(event.target);
});
function ebikeSmsMobile(value) {
  var mobile = String(value || '').trim().replace(/^(\+44|0044|44)\s*\(0\)/, '$1').replace(/[\s().-]/g, '');
  if (mobile.startsWith('00')) mobile = '+' + mobile.slice(2);
  if (/^44\d+$/.test(mobile)) mobile = '+' + mobile;
  else if (/^0\d+$/.test(mobile)) mobile = '+44' + mobile.slice(1);
  else if (/^7\d{9}$/.test(mobile)) mobile = '+44' + mobile;
  return mobile;
}
document.addEventListener('input', function (event) {
  var form = event.target.closest('.ebike-site-intake');
  if (form && event.target.name === 'buyerMobile') form.elements.namedItem('buyerMobile').setCustomValidity('');
});
document.addEventListener('submit', async function (event) {
  var form = event.target.closest('.ebike-site-intake');
  if (!form) return;
  event.preventDefault();
  var mobileInput = form.elements.namedItem('buyerMobile');
  var mobile = ebikeSmsMobile(mobileInput.value);
  mobileInput.setCustomValidity(mobile && !/^\+447(?:[1-5]|[7-9])\d{8}$/.test(mobile) ? form.dataset.smsMobileError : '');
  if (!form.reportValidity()) return;
  var offerInput = form.elements.namedItem('offerAmount');
  if (offerInput && ebikeRejectLowOffer(offerInput)) {
    offerInput.focus();
    return;
  }
  var modal = form.closest('#makeOfferModal, #reserveModal');
  var precheck = modal && modal.querySelector('[data-precheck]');
  var choice = precheck && precheck.querySelector('input[type="radio"]:checked');
  var postcode = precheck && precheck.querySelector('[data-postcode-input]');
  form.elements.namedItem('fulfilment').value = form.dataset.deliveryAvailable === 'false' ? 'Collection' : (choice ? choice.value : '');
  form.elements.namedItem('postcode').value = form.dataset.deliveryAvailable !== 'false' && choice && choice.value === 'Fully Assembled Delivery' && postcode ? postcode.value.trim().toUpperCase() : '';
  if (!form.elements.namedItem('intakeId').value) form.elements.namedItem('intakeId').value = crypto.randomUUID();
  var status = form.parentElement.querySelector('[data-intake-preview-status]');
  var button = form.querySelector('button[type="submit"]');
  var endpoint = form.dataset.intakeEndpoint;
  if (!endpoint) {
    status.textContent = 'Preview only. No request, email, order or payment was created.';
    status.hidden = false;
    button.disabled = true;
    return;
  }
  button.disabled = true;
  status.textContent = 'Checking the bike and sending your request…';
  status.hidden = false;
  var fields = new URLSearchParams({
    productHandle: form.dataset.productHandle || '',
    variantId: form.dataset.variantId || '',
    sku: form.dataset.sku || '',
    route: form.dataset.route || '',
    fulfilment: form.elements.namedItem('fulfilment').value,
    postcode: form.elements.namedItem('postcode').value,
    offerAmount: form.elements.namedItem('offerAmount') ? form.elements.namedItem('offerAmount').value : '',
    buyerName: form.elements.namedItem('buyerName').value.trim(),
    buyerEmail: form.elements.namedItem('buyerEmail').value.trim(),
    buyerMobile: mobile,
    intakeId: form.elements.namedItem('intakeId').value,
    deliveryPromotion: window.ebikeBuyerDeliveryOffer && window.ebikeBuyerDeliveryOffer.active() ? (form.dataset.deliveryPromotion || '') : ''
  });
  try {
    var response = await fetch(endpoint, {method: 'POST', headers: {'Content-Type': 'application/x-www-form-urlencoded'}, body: fields.toString(), credentials: 'omit', cache: 'no-store', referrerPolicy: 'no-referrer'});
    var result = await response.json();
    if (!response.ok || result.status !== 'received' || result.reference !== form.dataset.sku) {
      throw new Error(result.message || 'We could not send this request. Please contact info@ebikebuyer.com.');
    }
    status.textContent = (result.message || (form.dataset.route === 'Make Offer' ? 'Your offer has been sent.' : 'Your Buy Now request has been sent.')) + ' Reference: ' + result.reference;
    form.hidden = true;
    if (modal) modal.querySelector('.ebike-offer-modal__dialog, .ebike-reserve-modal__dialog').scrollTop = 0;
  } catch (error) {
    status.textContent = error.message || 'We could not send this request. Please try again.';
    button.disabled = false;
  }
});
  } catch(e) { console.error(e); }
})();

})();
